export default __webpack_public_path__ + "static/media/Design_HeroBanner_Image.4fe70c4d.png";